var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneRing = function SvgPhoneRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_ring_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.298 1.483c0-.473.384-.857.857-.857a8.286 8.286 0 0 1 8.286 8.286.857.857 0 1 1-1.714 0A6.57 6.57 0 0 0 8.155 2.34a.857.857 0 0 1-.857-.858Zm1.228 14.4a3.086 3.086 0 0 0 3.851-.412l.434-.434a1.04 1.04 0 0 0 0-1.463l-1.828-1.817a1.029 1.029 0 0 0-1.452 0 1.04 1.04 0 0 1-1.463 0L5.154 8.842a1.04 1.04 0 0 1 0-1.463 1.029 1.029 0 0 0 0-1.45l-1.76-1.83a1.04 1.04 0 0 0-1.463 0l-.434.435a3.086 3.086 0 0 0-.469 3.851 27.691 27.691 0 0 0 7.498 7.497Zm-.73-11.951a.857.857 0 1 0 0 1.714 3.714 3.714 0 0 1 3.715 3.715.857.857 0 1 0 1.714 0 5.429 5.429 0 0 0-5.428-5.43Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_ring_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgPhoneRing;